export default __webpack_public_path__ + "static/media/Snd_L_Starts.2186ca84.mp3";